import {GatewayError} from '@gravity-ui/gateway';
import {ErrorLayoutType} from 'common/constants';
import {System} from 'common/models/system';

interface GetRequestError {
    (error: unknown): System['error'];
}

const mapStatusToErrorLayoutType: Record<number, ErrorLayoutType> = {
    500: ErrorLayoutType.Unknown,
    403: ErrorLayoutType.AccessDenied,
};

const getErrorLayoutType = (status: number): ErrorLayoutType => {
    return mapStatusToErrorLayoutType[status] ?? ErrorLayoutType.Unknown;
};

const getRequestError: GetRequestError = (error) => {
    let result: System['error'] = ErrorLayoutType.Unknown;

    if (typeof error !== 'object' || !error) {
        throw result;
    }
    if ('isCancelled' in error) {
        return null;
    }
    if (!('status' in error) || !('code' in error)) {
        throw result;
    }

    const {status, code} = error as GatewayError;
    if (Object.values(ErrorLayoutType).some((value) => value === code)) {
        result = code as ErrorLayoutType;
    } else {
        result = getErrorLayoutType(status);
    }

    throw result;
};

export default getRequestError;
